import { render, staticRenderFns } from "./FilterBlockLayout.vue?vue&type=template&id=50591e38&"
import script from "./FilterBlockLayout.vue?vue&type=script&lang=js&"
export * from "./FilterBlockLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports